import axios from "axios";

const TokenKey = "token";

// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_URL,
  timeout: 20 * 1000,
  withCredentials: true
});

// request interceptor
service.interceptors.request.use(
  config => {
    // 自定义header
    config.headers["x-auth-token"] = localStorage.getItem(TokenKey);

    return config;
  },
  error => {
    // Do something with request error
    console.warn(error, "req,,,"); // for debug
    Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  response => {
    const { status, code, msg } = response.data;

    

    if (code != 0) {
      if (status == 401) {
        window.location.reload()
        localStorage.removeItem(TokenKey);
      }else{
        // TODO 报错提示处理
        console.warn(msg, "respose,,,");
        //return Promise.reject(msg);
        Promise.reject(msg);
        return msg
      }
    }else{
      if(status == 200){
        return response.data;
      }
    }
  },
  error => {
    const res = error.response;
    if (!res || !Object.keys(res).length) {
      // TODO 报错提示处理
      console.warn("当前网络状况不好，请重试", "error,,,");

      return Promise.reject(error);
    }

    return Promise.reject(res.data);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js